<template>
  <el-dialog custom-class="list-dialog fixwidth-dialog" title="审批单" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" @close="afterClose">
    <div class="search-content" >
      <el-col :span="24" class="toobar">
        <el-date-picker
          v-model="searchdatevalue"
          type="daterange" :value-format="'yyyy-MM-dd'"
          align="left" :unlink-panels="false"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions2">
        </el-date-picker>
        <el-input style="width:200px;"
                  placeholder="请输入标题"
                  v-model="handlename">
        </el-input>
        <el-input style="width:200px;"
                  placeholder="请输入单号"
                  v-model="erpserial">
        </el-input>
        <el-select v-model="todo" @change="searchdata" style="width:120px">
          <el-option key="100" label="待办事项" value="100"></el-option>
          <el-option key="200" label="我启动的" value="200"></el-option>
          <el-option key="300" label="我已处理" value="300"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="searchdata">搜索</el-button>
      </el-col>
    </div>
    <div style="width: 100%;float: left;">
    <Todolist ref="Todolist" :ToDopageSize="0" :ToDotableheight="tableHeight(155)" @afterBindTodo="afterBindTodo" :defaulttodo="defaulttodo" :ShowErpSerial="true"></Todolist>
    </div>
    <!--<div :style="'width: 12%;float: left;overflow: auto;height:'+tableHeight(155)+'px'">-->
    <!--<el-menu-->
      <!--:default-active="defaultactive" active-text-color="#409EFF"-->
      <!--:class="elmenuclass"  @select="selMenu">-->
      <!--<el-menu-item index="1" key="1">-->
        <!--<template >-->
          <!--<i class="iconfont icon-shouye"></i>-->
          <!--<span slot="title">全部单据</span>-->
        <!--</template>-->
      <!--</el-menu-item>-->
      <!--<el-menu-item v-for="(item, index) in menu" :index="item.menuguid" :key="item.menuguid">-->
        <!--<i :class="item.bigicon"></i>-->
        <!--<span slot="title">{{item.menuname}}</span>-->
      <!--</el-menu-item>-->
    <!--</el-menu>-->
      <!--</div>-->
  </el-dialog>
</template>
<script>
  import Todolist from '@/components/set/workflow/Todolist';
  import {pickerShortCuts} from '@/plugin/ordercommon';
  // import {getAuditMenu,getAPPMenu} from '@/api/login';

  export default {
    name: "ToDoDialog",
    data() {
      return {
        defaultactive:"1",
        elmenuclass:'el-menu-vertical-todo',
        todo: this.defaulttodo,
        dialogFormVisible: false,
        handlename:'',
        erpserial:'',
        menuguid:'',
        searchdatevalue:null,
        pickerOptions2: {
          shortcuts: []
        },
        menu:[],
        beginsearchnumber:'',
        endsearchnumber:'',
      }
    },
    props: {
      defaulttodo: {
        default: "100"
      }
    },
    methods: {
      selMenu(index, indexPath) {
        if(index=='1')
          index='';
        this.menuguid=index;
        this.searchdata();
      },
      searchdata(){
        this.bindgrid();
      },
      changeToDo(todo) {
        this.handlename='',
          this.erpserial='',
          this.searchdatevalue=null,
        this.dialogFormVisible = true;
        this.todo = todo;
        this.bindgrid();
      },
      bindgrid() {
        if (this.$refs.Todolist) {
          var startDate = '';
          var endDate = '';
          if (this.searchdatevalue != null && this.searchdatevalue != '') {
            var searchDate = new Date(this.searchdatevalue[0]);
            startDate = searchDate.getFullYear() + '-' + (searchDate.getMonth() + 1) + "-" + searchDate.getDate();
            searchDate = new Date(this.searchdatevalue[1]);
            endDate = searchDate.getFullYear() + '-' + (searchDate.getMonth() + 1) + "-" + searchDate.getDate();
          }

          this.$refs.Todolist.initData({
            handlename: this.handlename,//标题
            erpserial:this.erpserial,
            begindate: startDate,
            enddate: endDate,
            beginsearchnumber: this.beginsearchnumber,
            endsearchnumber: this.endsearchnumber,
            erpserial:this.erpserial,
            menuguid:'',
            todo: this.todo,
          });
        }
      },
      afterBindTodo(tableData) {
        console.log(tableData);
      },
      afterClose(){
        this.$emit('rebindToDo');
      }
    },
    mounted() {
      this.pickerOptions2.shortcuts = pickerShortCuts();
      // getAuditMenu().then(response =>{
      //   this.menu=response.data.menu;
      // })
      // getAPPMenu().then(response =>{
      //   console.log(response.data.menu)
      // })
    },
    components: {
      Todolist
    },
  }
</script>

<style scoped>
.el-menu-vertical-todo{
  border-right: solid 0px #e6e6e6;
  border-left: solid 1px #e6e6e6;
  list-style: none;
  position: relative;
  margin: 0;
  margin-left: 5px;
}

.el-menu-vertical-todo i{
  color: #000;
}
.el-menu-vertical-todo .is-active{
  background-color: #edf3ff;
}
el-menu-vertical-todo.is-active i{
  color: #409EFF !important;
}
.el-menu-vertical-todo li{
  padding-left: 10px !important;
}
.el-menu-vertical-todo .el-menu-item,.el-menu-vertical-todo .el-submenu__title{
    height: 34px;
    line-height: 34px;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/workflow/ToDoDialog.vue